export const ANALYTICS_CONSTANTS = {
  MAX_DAILY_RANGE_DAYS: 90,
  DEFAULT_DAY_RANGE_DAYS: 30,
  DEFAULT_MONTHLY_LOOKBACK_MONTHS: 12,
  EARLIEST_DATA_YEAR: 2024,
} as const;

export const CATEGORY_IDS = {
  SESSION_PERFORMANCE: 'session-performance',
  UTILIZATION: 'utilization',
  WELLNESS: 'wellness',
  SYSTEM_PERFORMANCE: 'system-performance',
} as const;

export type AnalyticsCategoryId = (typeof CATEGORY_IDS)[keyof typeof CATEGORY_IDS];
export type GranularityMode = 'day' | 'month';
